<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Image({
              label: 'Zdjęcie',
              required: true,
              modelPath: [this, 'form', 'image']
            })
          ]
        }
      ]
    }
  }
}
</script>
